import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

export default function ComeFunzionaPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "Come Funziona Vertiix - Processo in 5 Fasi",
    "description": "Cinque fasi sequenziali che trasformano la frammentazione in sistema governabile: Allineamento & Regia, Progettazione del Sistema, Produzione & Implementazione, Controllo & Lettura, Ottimizzazione & Continuità. Processo lineare per crescita prevedibile.",
    "step": [
      {
        "@type": "HowToStep",
        "position": 1,
        "name": "Allineamento & Regia",
        "text": "Definizione della strategia unificata e della regia centrale per coordinare tutte le attività digitali."
      },
      {
        "@type": "HowToStep",
        "position": 2,
        "name": "Progettazione del Sistema",
        "text": "Architettura del sistema operativo della crescita con flussi, processi e strumenti integrati."
      },
      {
        "@type": "HowToStep",
        "position": 3,
        "name": "Produzione & Implementazione",
        "text": "Costruzione e implementazione dell'infrastruttura digitale con produzione coordinata e continuativa."
      },
      {
        "@type": "HowToStep",
        "position": 4,
        "name": "Controllo & Lettura",
        "text": "Sistema di monitoraggio e analisi per decisioni basate su dati leggibili e performance misurabili."
      },
      {
        "@type": "HowToStep",
        "position": 5,
        "name": "Ottimizzazione & Continuità",
        "text": "Miglioramento continuo del sistema con ottimizzazioni basate su dati e mantenimento della continuità operativa."
      }
    ]
  };

  const fasi = [
    {
      numero: '01',
      titolo: 'Allineamento & Regia',
      descrizione: 'Stabiliamo la direzione strategica e il controllo centrale. Nessuna azione prima della visione.',
      scopo: 'Eliminare ambiguità e creare una base decisionale solida',
      risultato: 'Sistema di governo chiaro e condiviso',
      image: 'https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/81f247ff1be691c4290cbd8858bc4147.png'
    },
    {
      numero: '02',
      titolo: 'Progettazione del Sistema',
      descrizione: 'Costruiamo l\'infrastruttura operativa: flussi, strumenti, metriche, responsabilità. Tutto coordinato. Senza questa fase, ogni esecuzione diventa inefficiente.',
      scopo: 'Trasformare la strategia in architettura eseguibile',
      risultato: 'Blueprint completo del sistema di crescita',
      image: 'https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/df5ae0c807969e366f105209866e8c7e.png'
    },
    {
      numero: '03',
      titolo: 'Produzione & Implementazione',
      descrizione: 'Attiviamo il sistema progettato: asset, flussi, automazioni e integrazioni operano come un’unica macchina.',
      scopo: 'Rendere operativo il sistema progettato',
      risultato: 'Macchina di produzione attiva e funzionante',
      image: 'https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/924bb15ad6436a14d9d2e5a387714f20.png'
    },
    {
      numero: '04',
      titolo: 'Controllo & Lettura',
      descrizione: 'Monitoriamo performance, interpretiamo dati, identifichiamo pattern. Nessuna decisione senza lettura.',
      scopo: 'Garantire visibilità totale e capacità decisionale',
      risultato: 'Dashboard di controllo e intelligence operativa',
      image: 'https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/0321738e2bf1acc02c8b2cc8e6d87f9d.png'
    },
    {
      numero: '05',
      titolo: 'Ottimizzazione & Continuità',
      descrizione: 'Raffiniamo ed evolviamo. Il sistema cresce senza perdere coerenza.',
      scopo: 'Mantenere il vantaggio competitivo nel tempo',
      risultato: 'Crescita prevedibile e sostenibile',
      image: 'https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/093a1bd11c1512c4b7408ce4a7929feb.png'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Come Funziona Vertiix - Processo in 5 Fasi"
        description="Cinque fasi sequenziali che trasformano la frammentazione in sistema governabile: Allineamento & Regia, Progettazione del Sistema, Produzione & Implementazione, Controllo & Lettura, Ottimizzazione & Continuità. Processo lineare per crescita prevedibile."
        keywords="processo vertiix, fasi digital factory, allineamento strategico, progettazione sistema, implementazione marketing, controllo performance, ottimizzazione continua"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/come-funziona`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
        schema={schema}
      />
      
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-16 md:h-24"
              />
            </Link>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
            </button>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Home</Link>
              <Link to="/problema" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Il Problema</Link>
              <Link to="/vertiix" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Cos'è Vertiix</Link>
              <Link to="/come-funziona" className="text-teal-600 text-sm font-medium">Come Funziona</Link>
              <Link to="/accesso" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Come Si Accede</Link>
              <Link to="/valutazione" className="px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer">VALUTAZIONE</Link>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-teal-600 font-medium transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 text-sm font-medium rounded-full mb-6">
            Processo Lineare
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Come Funziona Vertiix
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Cinque fasi sequenziali che trasformano la frammentazione in sistema governabile. 
            Ogni fase riduce incertezza e prepara la successiva.
          </p>
        </div>
      </section>

      {/* Messaggio Chiave */}
      <section className="py-12 md:py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xl md:text-2xl font-semibold text-gray-900 leading-relaxed">
            Senza processo, qualsiasi investimento diventa imprevedibile.
          </p>
        </div>
      </section>

      {/* Fasi del Processo */}
      <section className="py-16 md:py-24 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="space-y-20 md:space-y-32">
            {fasi.map((fase, index) => (
              <div key={fase.numero} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 xl:gap-16 items-center`}>
                {/* Immagine */}
                <div className="w-full lg:w-1/2">
                  <div className="relative">
                    <div className="absolute -top-4 -left-4 md:-top-6 md:-left-6 text-6xl md:text-8xl font-bold text-teal-100 select-none">
                      {fase.numero}
                    </div>
                    <div className="relative w-full h-64 md:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-xl">
                      <img 
                        src={fase.image} 
                        alt={fase.titolo}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                </div>

                {/* Contenuto */}
                <div className="w-full lg:w-1/2">
                  <div className="space-y-4 md:space-y-6">
                    <div>
                      <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-teal-100 text-teal-600 rounded-lg mb-4">
                        <span className="text-lg md:text-xl font-bold">{fase.numero}</span>
                      </div>
                      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
                        {fase.titolo}
                      </h2>
                      <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                        {fase.descrizione}
                      </p>
                    </div>

                    <div className="space-y-4 pt-4">
                      <div className="border-l-4 border-teal-600 pl-4 md:pl-6">
                        <div className="text-xs md:text-sm font-semibold text-teal-600 uppercase tracking-wide mb-1">
                          Scopo
                        </div>
                        <p className="text-sm md:text-base text-gray-700 font-medium">
                          {fase.scopo}
                        </p>
                      </div>

                      <div className="border-l-4 border-gray-300 pl-4 md:pl-6">
                        <div className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                          Risultato
                        </div>
                        <p className="text-sm md:text-base text-gray-700 font-medium">
                          {fase.risultato}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Linearità del Processo */}
      <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Perché un Processo Lineare
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Ogni fase è propedeutica alla successiva. Non si può ottimizzare ciò che non è stato implementato.
              Non si può implementare ciò che non è stato progettato.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Prevedibilità
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Ogni fase ha input e output definiti. Nessuna improvvisazione.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Scalabilità
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Il sistema cresce senza perdere coerenza o controllo.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-compass-3-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Controllo
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Visibilità totale su ogni componente del sistema.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Il Processo Inizia con la Valutazione
          </h2>
          <p className="text-lg text-gray-600 mb-10 leading-relaxed max-w-2xl mx-auto">
            Prima di attivare qualsiasi fase, verifichiamo la compatibilità strategica. 
            Non tutte le aziende sono pronte per questo livello di struttura.
          </p>
          <Link 
            to="/valutazione" 
            className="inline-block px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Richiedi Valutazione
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-12">
            <div className="md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-48 mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-white mb-6">Navigazione</h4>
              <nav className="space-y-3">
                <Link to="/" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Contatti</h4>
              <p className="text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-6 sm:pt-7 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-gray-500 text-center md:text-left">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}